import { CLIENT_BUILD } from '../lib/update.js';

/**
 * Whether THIS screen is running the build the server is. A mismatch is a
 * stale iPad - the old code still on screen after a deploy - and that is a
 * thing to see, not to find out about from a child.
 *
 * It describes the device it is open on, so open Admin on each iPad to check
 * that one.
 */
export function BuildCheck({
  server,
  client = CLIENT_BUILD,
}: {
  server?: string;
  client?: string;
}) {
  if (server === undefined) return null;
  const known = server !== 'unknown' && client !== 'unknown' && client !== 'dev';
  const same = known && server === client;
  return (
    <p className="muted">
      This screen <code>{client}</code> · server <code>{server}</code>{' '}
      {same ? (
        <span className="pill pill--ok">up to date</span>
      ) : (
        <span className="pill pill--warn">
          {known ? 'this screen is out of date' : 'build not recorded - deploy with GIT_SHA set'}
        </span>
      )}
    </p>
  );
}
